import{AspectBox as xr}from"@fourthwall/components/dist/common/AspectBox/AspectBox";import{Skeleton as M}from"@fourthwall/components/dist/partials/Skeleton";import s,{memo as br}from"react";import{Swatch as _t}from"@fourthwall/components/dist/common/Swatch";import{Tooltip as Ft}from"@fourthwall/components/dist/common/Tooltip";import{Checkbox as Zt}from"@fourthwall/components/dist/inputs/Checkbox";import{Radio as Kt}from"@fourthwall/components/dist/ui/Radio";import{QuestionMarkDarkIcon as Qt,ZoomInIcon as qt}from"@fourthwall/icons";import d from"react";import{mediaQueries as U}from"@fourthwall/components/dist/providers/MediaQueryProvider";import P,{css as A}from"styled-components";var mo=P.div`
  & > * + * {
    ${({$spacing:o=6})=>A`
      margin-top: ${o}px;
    `}}
  }
`,Co=P.div`
  ${({$gutter:o=20})=>A`
    margin-left: ${o}px;
    margin-right: ${o}px;
  `}}
`,Po=P.div`
  margin-top: var(--space-300);
`,vo=P.p`
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  color: var(--text-primary);

  ${U.tablet} {
    font-size: var(--font-size-400);
    line-height: var(--font-line-height-400);

    ${({$size:o})=>o==="compact"&&A`
        font-size: var(--font-size-200);
        line-height: var(--font-line-height-200);
        font-weight: var(--font-weight-medium);
      `}
  }

  ${({$hoverable:o})=>o&&A`
      &:hover {
        color: var(--text-brand);
      }
    `}
`,ho=P.p`
  font-size: var(--font-size-200);
  line-height: var(--font-line-height-200);
  color: var(--text-secondary);

  ${U.tablet} {
    font-size: var(--font-size-300);
    line-height: var(--font-line-height-300);
  }
`,go=P.div`
  display: flex;
  padding: 0;
  gap: var(--space-150);
  flex-wrap: wrap;
`,fo=P.div`
  font-size: var(--font-size-200);
  line-height: var(--font-line-height-200);
  padding: var(--space-50) var(--space-200);

  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-full);
  white-space: nowrap;
  color: var(--text-secondary);

  display: flex;
  gap: var(--space-200);
  justify-content: start;
  align-items: center;
`,W=P.p`
  display: flex;
  flex-direction: column;
  vertical-align: center;
  color: var(--text-secondary);
  font-size: var(--font-size-200);
  line-height: var(--font-line-height-200);

  ${U.tablet} {
    font-size: var(--font-size-300);
    line-height: var(--font-line-height-300);

    ${({$size:o})=>o==="compact"&&A`
        font-size: var(--font-size-200);
        line-height: var(--font-line-height-200);
        font-weight: var(--font-weight-regular);
      `}
  }

  & > :not(:first-child) {
    margin-top: var(--space-100);
  }

  @container card (min-width: 300px) {
    flex-direction: row;

    & > :not(:first-child) {
      margin-top: 0;

      &:before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 1px;
        height: var(--space-400);
        background-color: var(--border-secondary);
        margin: 0 var(--space-250);
      }
    }
  }
`,yo=P.div`
  margin-top: var(--space-300);
`,_=P.div`
  position: relative;
  overflow: hidden;
  padding-bottom: 133%; /* aspect-ratio: 3/4 */

  ${({$outline:o})=>o&&A`
      outline: 1px solid var(--border-brand);
    `}
`,F=P.div`
  position: absolute;
  top: var(--space-100);
  left: var(--space-100);

  z-index: 2;

  display: flex;

  > * + * {
    margin-left: var(--space-100);
  }
`,Z=P.span`
  display: none;
  padding: var(--space-100) var(--space-300);
  align-items: center;
  gap: var(--space-200);

  position: absolute;
  top: var(--space-200);
  right: var(--space-200);
  z-index: 2;

  color: var(--text-primary);

  border-radius: var(--radius-full);
  background: var(--bg-primary);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);

  text-align: center;
  white-space: nowrap;

  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);

  cursor: pointer;

  &:hover {
    background: var(--bg-primary-hover);
  }
`,K=P.span`
  display: none;

  height: 29px;
  align-content: center;
  color: var(--text-primary);
`,Q=P.label`
  cursor: pointer;
  height: 29px;

  // this is Ugly - remove when product-customization v1 is deprecated
  ${({$relative:o})=>o&&A`
      position: relative;
    `}

  ${({checked:o,$outline:t})=>o&&t&&A`
      border-color: var(--border-brand);
    `}

  &:hover {
    ${Z} {
      display: inline-flex;
    }

    ${K} {
      display: block;
    }
  }
`,q=P.div`
  position: absolute;
  top: var(--space-200);
  left: var(--space-200);
  z-index: 2;

  height: 29px;
  align-content: center;
`,xo=P.span`
  display: inline-flex;
  align-items: center;
`,bo=P.span`
  color: var(--text-secondary);
  margin-left: var(--space-100);
`,So=P.div`
  display: grid;
  /* 20px = size of the color swatch */
  grid-template-columns: repeat(auto-fit, minmax(20px, min-content));
  gap: var(--space-300);
`;import{Swatch as bt}from"@fourthwall/components/dist/common/Swatch";import Y from"react";import j,{css as ft}from"styled-components";var Vo=j.div`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(auto-fill, 12px);
  gap: var(--space-200);
`,Bo=j.span`
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-200);

  ${({$size:o})=>o==="compact"&&ft`
      font-weight: var(--font-weight-regular);
      font-size: var(--font-size-200);
      line-height: var(--font-line-height-200);
    `}

  color: var(--text-secondary);
`,ae=j.div`
  width: 12px;
  height: 12px;
  box-shadow: inset 0px 0px 0px 1px
    ${({$light:o})=>o?"var(--border-primary)":"transparent"};
  border-radius: 50%;
`;import{useMemo as xt}from"react";var Mo=4,zo=({colors:o,hiddenColorsCount:t=0})=>{let r=xt(()=>({toShow:o.slice(0,Mo),toCount:o.slice(Mo,o.length)}),[o]),n=r.toCount.length+t;return{limitedColors:r,count:n}};var J=({colors:o,hiddenColorsCount:t,size:r})=>{let{limitedColors:n,count:i}=zo({colors:o,hiddenColorsCount:t});return Y.createElement(Vo,null,n.toShow.map(({name:a,swatch:l})=>Y.createElement(bt,{key:a,size:"xsmall",fill:l,active:!1})),i>0&&Y.createElement(Bo,{$size:r,"data-testid":"AvailableColors.Rest"},"+",i))};import T from"react";import{mediaQueries as St}from"@fourthwall/components/dist/providers/MediaQueryProvider";import x,{css as wo}from"styled-components";var Ao=x.div`
  position: relative;
  z-index: 0;
`,X=x.div`
  position: absolute;
  bottom: 4px;
  left: 4px;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.1s ease-in-out,
    visibility 0.1s ease-in-out;
`,R=x.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--radius-brand);
`,oo=x.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: none;
  border-radius: var(--radius-brand);
`,ko=x.div`
  position: relative;
  z-index: 0;

  & > * + * {
    margin-top: var(--space-300);
  }

  &:hover {
    ${({$compact:o,$onHoverActive:t})=>o&&t&&wo`
        ${X} {
          opacity: 1;
          visibility: visible;
        }

        ${R} {
          display: none;
        }

        ${oo} {
          display: block;
        }
      `}
  }
`,to=x.div`
  position: absolute;
  top: 0;
  z-index: 1;
  width: 100%;
  display: none;
`,To=x.div`
  position: relative;
  z-index: 0;
`,ro=x.div`
  position: absolute;
  top: -16px;
  left: -16px;
  z-index: -1;
  width: calc(100% + 32px);
  height: calc(100% + 32px);
  display: none;
  background-color: var(--bg-primary);
`,eo=x.div`
  position: absolute;
  top: 0;
  left: -16px;
  z-index: -1;
  width: calc(100% + 32px);
  height: calc(100% + 16px);
  display: none;
  background-color: var(--bg-primary);
`,Io=x.div`
  container: card / inline-size;
  user-select: none;
  position: relative;
  z-index: 0;
  display: block;

  ${({$interactive:o})=>o&&wo`
      ${St.laptop} {
        &:hover {
          z-index: 1;

          ${ro},
          ${eo},
          ${to} {
            display: block;
          }
        }
      }
    `}
`;var g=({interactive:o=!0,children:t})=>T.createElement(Io,{$interactive:o},T.createElement(Ao,null,t,T.createElement(ro,null))),Bt=({children:o,compact:t,onMouseEnter:r,onMouseLeave:n,onHoverActive:i})=>T.createElement(ko,{onMouseEnter:r,onMouseLeave:n,$compact:t,$onHoverActive:i},o),Mt=({children:o})=>T.createElement(to,null,o,T.createElement(eo,null)),zt=({children:o})=>T.createElement(To,null,o);g.Content=Bt;g.ContentOnMouseEnter=Mt;g.ContentOnMouseLeave=zt;g.ColorsCountBadge=X;g.Image=R;g.ImageSecond=oo;import wt from"lodash-es/debounce";import{useRef as Eo,useState as At}from"react";var kt=500,Tt=200,no=(o=!1,t={timeToInteractive:kt,timeToRespond:Tt})=>{let r=Eo(null),n=Eo(),[i,a]=At(o),l=u=>{let y=wt(u,t.timeToRespond,{leading:!0,trailing:!1});n.current?.cancel(),y(),n.current=y},c=()=>{n.current?.cancel()};return{interactive:i,onInteractivity:u=>{r.current=setTimeout(()=>{u?.(),a(!0)},t.timeToInteractive)},cancelInteractivity:()=>{r.current&&clearTimeout(r.current),c(),a(!1)},debounceInteractivity:l}};import{getPrice as $o}from"@fourthwall/utils/dist/common";var ao=(o,t)=>o===t?`${$o(o)}`:`From ${$o(o)}`;import{Tooltip as $t}from"@fourthwall/components/dist/common/Tooltip";import Lo from"react";import It,{css as io}from"styled-components";var No=It.span`
  display: block;

  text-align: center;
  font-weight: var(--font-weight-semibold);

  ${({$size:o})=>o==="xsmall"?io`
        font-size: var(--font-size-100);
        line-height: var(--font-line-height-100);
        padding: var(--space-50) var(--space-150);
        letter-spacing: var(--font-letter-spacing-loosest);
      `:o==="small"?io`
        font-size: var(--font-size-200);
        line-height: var(--font-line-height-200);
        padding: var(--space-50) var(--space-150);
        letter-spacing: var(--font-letter-spacing-loose);
      `:io`
      font-size: var(--font-size-300);
      line-height: var(--font-line-height-200);
      padding: var(--space-100) var(--space-250);
      letter-spacing: var(--font-letter-spacing-loose);
    `}
`;var Nt={dark:"var(--bg-primary-invert)",light:"var(--bg-primary)",primary:"var(--bg-brand)",secondary:"var(--bg-primary)"},Lt={dark:"var(--text-primary-invert)",light:"var(--text-secondary)",primary:"var(--text-on-brand)",secondary:"var(--text-primary)"},N=({tooltip:o,label:t,type:r="secondary",size:n,borderRadius:i="100px"})=>{let a=Lo.createElement(No,{$size:n,style:{backgroundColor:Nt[r],color:Lt[r],borderRadius:i}},t);return o?Lo.createElement($t,{reference:a,strategy:"fixed",fluid:!0},o):a};import Gt,{createContext as Ht,useContext as Ut,useMemo as Wt}from"react";import{useEffect as Ot,useState as Dt}from"react";var Oo=(o,t)=>{let[r,n]=Dt(t??o[0]),i=l=>o.find(c=>c.color.swatch===l),a=l=>{let c=i(l)??o[0];n(c)};return Ot(()=>{let l=o.some(c=>c.color.name===t?.color.name)?t:o[0];l&&n(l)},[t,o]),{activeColorVariant:r,setActiveColorVariant:n,getColorVariantByColorValue:i,setActiveColorVariantByColorValue:a}};var Do=Ht(void 0),Ee=({colorVariants:o,initialColorVariant:t,children:r})=>{let{activeColorVariant:n,setActiveColorVariant:i,getColorVariantByColorValue:a,setActiveColorVariantByColorValue:l}=Oo(o,t??o[0]),c=Wt(()=>({colorVariants:o,activeColorVariant:n,setActiveColorVariant:i,getColorVariantByColorValue:a,setActiveColorVariantByColorValue:l}),[o,n,i,a,l]);return Gt.createElement(Do.Provider,{value:c},r)};function I(){let o=Ut(Do);if(o===void 0)throw new Error("useProductColorVariantContext must be used within a ProductColorVariantProvider");return o}var Go=(o,t)=>{let r=Array.from(t).reduce((a,l)=>a+l.charCodeAt(0),0),n=r%o,i=r*31%o;return o>1&&i===n&&(i=(n+1)%o),{randomNumberOne:n,randomNumberTwo:i}};var e=({interactive:o,children:t})=>d.createElement(g,{interactive:o},t),jt=({children:o,compact:t,onHoverActive:r})=>{let{onInteractivity:n,cancelInteractivity:i}=no(),a=()=>{n()},l=()=>{i()};return d.createElement(g.Content,{onMouseEnter:a,onMouseLeave:l,compact:t,onHoverActive:r},o)},Yt=({children:o,spacing:t=6})=>d.createElement(mo,{$spacing:t},o),Jt=({children:o,gutter:t=20})=>d.createElement(Co,{$gutter:t},o),Xt=({children:o})=>d.createElement(ho,null,o),Rt=({price:o,minimum:t,size:r})=>d.createElement(W,{$size:r},d.createElement("span",null,ao(o.from.value,o.to.value)),d.createElement(Ho,{quantity:t})),or=({price:o,size:t})=>d.createElement(W,{$size:t},d.createElement("span",null,ao(o.from.value,o.to.value))),tr=({children:o})=>d.createElement(yo,null,o),rr=({colorsAvailable:o,colorsOther:t,size:r})=>{let{colorVariants:n}=I();return n.length===1?null:d.createElement(J,{colors:o,hiddenColorsCount:t.length,size:r})},er=({children:o})=>d.createElement(g.ContentOnMouseEnter,null,o),nr=({children:o})=>d.createElement(Po,null,d.createElement(g.ContentOnMouseLeave,null,o)),ar=()=>{let{colorVariants:o,activeColorVariant:t,setActiveColorVariantByColorValue:r}=I(),{debounceInteractivity:n}=no(),i=a=>{n(()=>{r(a.swatch)})};return o.length<=1?null:d.createElement(So,null,o.map(({color:a})=>d.createElement(_t,{key:a.name,size:"medium",variant:"selectable",fill:a.swatch,active:a.name===t.color.name,onMouseEnter:()=>{i(a)}})))},ir=({checked:o,name:t,value:r,label:n,showLabelOnHover:i=!1,relative:a=!1,outline:l,children:c,onChange:C})=>d.createElement(Q,{checked:o,"aria-label":n,"aria-checked":o,$outline:l,$relative:a},d.createElement(q,null,d.createElement(Zt,{name:t,value:r,checked:o,native:!0,onChange:C,label:d.createElement(K,null,i&&(o?"":"Add\xA0product"))})),c),sr=({checked:o,name:t,value:r,label:n,children:i,onChange:a})=>d.createElement(Q,{checked:o,"aria-label":n,"aria-checked":o},d.createElement(q,null,d.createElement(Kt,{name:t,value:r,checked:o,onChange:a})),i),dr=({badges:o,alt:t,outline:r})=>{let{activeColorVariant:n}=I();return d.createElement(_,{$outline:r,$compact:!1},d.createElement(F,null,o.map(i=>d.createElement(N,{key:i.label,...i,size:"small"}))),d.createElement(g.Image,{src:n.photoUrl,alt:t}))},lr=({badges:o,alt:t,outline:r,seed:n})=>{let{colorVariants:i}=I(),a=i.length,{randomNumberOne:l,randomNumberTwo:c}=Go(a,n);return d.createElement(_,{$outline:r,$compact:!0},d.createElement(F,null,o.map(C=>d.createElement(N,{key:C.label,...C,size:"small"}))),d.createElement(g.Image,{src:i[l].photoUrl,alt:t}),d.createElement(g.ImageSecond,{src:i[c].photoUrl,alt:t}),a>1&&d.createElement(g.ColorsCountBadge,null,d.createElement(N,{label:`${a} colors`,type:"light",size:"small",borderRadius:"4px"})))},Ho=({quantity:o})=>o?d.createElement(xo,null,"minimum ",o,d.createElement(bo,null,d.createElement(Ft,{reference:d.createElement(Qt,{width:14})},d.createElement("span",null,"This product has a minimum order requirement of ",o,". You can reach the minimum by collecting pre-orders (no upfront payment required).")))):d.createElement("span",null,"no minimum"),cr=({children:o})=>d.createElement(go,null,o),pr=({children:o,onClick:t})=>d.createElement(fo,{onClick:t},o),ur=({onClick:o})=>d.createElement(Z,{onClick:o},d.createElement(qt,{width:14,height:14}),"Zoom in");e.Label=ir;e.ZoomInButton=ur;e.Radio=sr;e.Body=jt;e.Space=Yt;e.HorizontalGutter=Jt;e.Brand=Xt;e.Name=vo;e.Price=Rt;e.PriceCompact=or;e.Pills=cr;e.Pill=pr;e.Details=tr;e.AvailableColors=rr;e.ContentOnMouseEnter=er;e.ContentOnMouseLeave=nr;e.ContentColorway=ar;e.Thumbnail=dr;e.ThumbnailCompact=lr;e.QuantityMessage=Ho;import mr,{createContext as Cr,useContext as Pr}from"react";var Uo=Cr(void 0);function E({href:o,children:t,onClickLink:r}){let n=i=>{r&&r({event:i})};return mr.createElement(Uo.Provider,{value:{onClickLink:n,href:o}},t)}function Wo(){let o=Pr(Uo);if(o===void 0)throw new Error("useProductNavigationContext must be used within a ProductNavigationProvider");return o}import vr from"react";var k=({children:o})=>{let{onClickLink:t,href:r}=Wo();return vr.createElement("a",{href:r,onClick:t,style:{display:"block"}},o)};import Fo,{css as _o}from"styled-components";var Zo=Fo.div`
  margin-top: var(--space-300);
  margin-bottom: var(--space-300);
`,L=Fo.div`
  margin-top: var(--space-300);
  margin-bottom: var(--space-300);

  ${({$size:o})=>o==="compact"&&_o`
      margin-top: var(--space-300);
      margin-bottom: var(--space-100);
    `}

  ${({$size:o})=>o==="large"&&_o`
      margin-top: var(--space-500);
      margin-bottom: var(--space-500);
    `}
`;import*as f from"react";import{useMediaQueryContext as hr}from"@fourthwall/components/dist/providers/MediaQueryProvider";import{useMemo as gr}from"react";var so={ACRYLIC_CUTOUT:"Acrylic cutout",ALL_OVER_PRINT:"All over printed",DRINKWARE:"Drinkware",DIE_CUT_MAGNET:"Die cut magnet",DTFX:"DTFx",DTG:"DTG",EMBROIDERY:"Embroidered",GARMENT_PRINTED:"Printed on demand",HOLO_STICKER:"Holographic sticker",KNITTING:"Knitted",OTHER:"Other",PRINTED:"Digital printed",SCREEN_PRINTING:"Screen printed",STICKER:"Sticker",SUBLIMATION:"Sublimation",UV:"UV"};var fr=()=>{let o=f.useContext(lo),r=hr().laptop?2:1;return f.createElement(f.Fragment,null,o.productionMethodsKeys.slice(0,r).map(n=>f.createElement(e.Pill,{key:n},so[n])),o.productionMethodsKeys.length>r&&f.createElement(e.Pill,null,"+",o.productionMethodsKeys.length-r))},yr=({setActiveProductionMethod:o})=>{let t=f.useContext(lo);return f.createElement(f.Fragment,null,t.productionMethodsKeys.map(r=>f.createElement(e.Pill,{key:r,onClick:()=>{o(r)}},so[r])))},lo=f.createContext(null),b=({product:o,children:t})=>{let r=gr(()=>({productionMethodsKeys:Object.keys(o.groupedProductionMethods)}),[o.groupedProductionMethods]);return f.createElement(lo.Provider,{value:r},f.createElement(e.Pills,null,t))};b.Static=fr;b.Interactive=yr;var O=({checked:o=!1,interactive:t=!0,product:r,onClickLink:n,href:i,activeProduct:a,setActiveProductionMethod:l})=>s.createElement(e,{interactive:t},s.createElement(E,{href:i,onClickLink:n},s.createElement(e.Body,null,s.createElement(e.Thumbnail,{badges:[],outline:o,alt:`Photo showing ${r.name}`}),s.createElement(e.ContentOnMouseLeave,null,s.createElement(e.Space,{spacing:6},s.createElement(e.Space,{spacing:4},s.createElement(e.Brand,null,t?s.createElement(k,null,`${r.brand} ${r.brandModel}`):s.createElement("p",null,`${r.brand} ${r.brandModel}`)),t?s.createElement(k,null,s.createElement(e.Name,{$hoverable:!0},r.name)):s.createElement(e.Name,{$hoverable:!1},r.name)),s.createElement(e.Space,{spacing:8},s.createElement(b,{product:r},s.createElement(b.Static,null)),s.createElement(e.Price,{price:{from:{value:a.priceFrom,currency:"USD"},to:{value:a.priceTo,currency:"USD"}},minimum:a.minimumOrdersNumber})),s.createElement(L,null,s.createElement(e.AvailableColors,{colorsAvailable:a.colorVariants.matched.map(({color:c})=>c),colorsOther:a.colorVariants.other.map(({color:c})=>c)}))),s.createElement(e.ContentOnMouseEnter,null,s.createElement(e.Space,{spacing:6},s.createElement(e.Space,{spacing:4},s.createElement(e.Brand,null,t?s.createElement(k,null,`${r.brand} ${r.brandModel}`):s.createElement("p",null,`${r.brand} ${r.brandModel}`)),t?s.createElement(k,null,s.createElement(e.Name,null,r.name)):s.createElement(e.Name,{$hoverable:!1},r.name)),s.createElement(e.Space,{spacing:8},s.createElement(b,{product:r},s.createElement(b.Interactive,{setActiveProductionMethod:l})),s.createElement(e.Price,{price:{from:{value:a.priceFrom,currency:"USD"},to:{value:a.priceTo,currency:"USD"}},minimum:a.minimumOrdersNumber})),s.createElement(Zo,null,s.createElement(e.ContentColorway,null)))))))),Sr=o=>s.createElement(e.Label,{relative:!0,checked:o.checked,label:o.label,value:o.value,name:o.name,onChange:o.onChange},o.children),Vr=o=>s.createElement(e.Radio,{checked:o.checked,label:o.label,value:o.value,name:o.name,onChange:o.onChange},o.children),Br=o=>s.createElement(e.ZoomInButton,{onClick:o.onClick}),Mr=()=>s.createElement(M,{gap:8},s.createElement(xr,{ratio:"7.5:10"},s.createElement(M.Shape,{width:"100%"})),s.createElement(M.Shape,{width:"66%",height:16}),s.createElement(M.Shape,{width:"80%",height:24}),s.createElement(M.Shape,{width:"75%",height:16}),s.createElement(M,{aligment:"horizontal",gap:8},s.createElement(M.Shape,{radius:"50%",width:12,height:12}),s.createElement(M.Shape,{radius:"50%",width:12,height:12}),s.createElement(M.Shape,{radius:"50%",width:12,height:12})));O.Skeleton=br(Mr);O.Label=Sr;O.Radio=Vr;O.ZoomInButton=Br;import{AspectBox as zr}from"@fourthwall/components/dist/common/AspectBox/AspectBox";import{Skeleton as z}from"@fourthwall/components/dist/partials/Skeleton";import v,{memo as wr}from"react";var Ar=({product:o,size:t="regular",isWebView:r=!1,onClickLink:n,href:i,activeProduct:a})=>v.createElement(e,{interactive:!1},v.createElement(E,{href:i,onClickLink:n},v.createElement(e.Body,{compact:!0,onHoverActive:!r},v.createElement(e.ThumbnailCompact,{badges:[],outline:!1,alt:`Photo showing ${o.name}`,seed:o.id}),v.createElement(e.Space,{spacing:6},v.createElement(e.Space,{spacing:4},v.createElement(e.Name,{$hoverable:!1,$size:t},o.name)),v.createElement(e.PriceCompact,{size:t,price:{from:{value:a.priceFrom,currency:"USD"},to:{value:a.priceTo,currency:"USD"}}}))))),kr=()=>v.createElement(z,{gap:8},v.createElement(zr,{ratio:"7.5:10"},v.createElement(z.Shape,{width:"100%"})),v.createElement(z.Shape,{width:"66%",height:16}),v.createElement(z.Shape,{width:"80%",height:24}),v.createElement(z.Shape,{width:"75%",height:16}),v.createElement(z,{aligment:"horizontal",gap:8},v.createElement(z.Shape,{radius:"50%",width:12,height:12}),v.createElement(z.Shape,{radius:"50%",width:12,height:12}),v.createElement(z.Shape,{radius:"50%",width:12,height:12})));Ar.Skeleton=wr(kr);import{AspectBox as Ir}from"@fourthwall/components/dist/common/AspectBox/AspectBox";import{Skeleton as w}from"@fourthwall/components/dist/partials/Skeleton";import p,{memo as Er}from"react";import Tr,{css as co}from"styled-components";var Qo=Tr.div`
  ${({$outline:o})=>o==="heavy"&&co`
      outline: 2px solid var(--border-brand);
    `}

  ${({$outline:o})=>o==="medium"&&co`
      outline: 1px solid var(--border-primary);
    `}

  ${({$outline:o})=>o==="light"&&co`
      outline: 1px solid var(--border-tertiary);

      &:hover {
        outline: 1px solid var(--border-primary);
      }
    `}
`;var $r=({checked:o=!1,product:t,onClickLink:r,onCheckboxChange:n,onZoomInClick:i,href:a,children:l})=>p.createElement(Qo,{$outline:o?"heavy":"light"},p.createElement(e,{interactive:!1},p.createElement(E,{href:a,onClickLink:r},p.createElement(e.Label,{showLabelOnHover:!0,outline:!1,checked:o,label:t.name,value:t.id,name:t.name,onChange:n},p.createElement(e.ZoomInButton,{onClick:C=>{C.preventDefault(),i(C)}}),p.createElement(e.Body,null,p.createElement(e.Thumbnail,{badges:[],outline:!1,alt:`Photo showing ${t.name}`}),p.createElement("div",{style:{marginTop:"20px"}},p.createElement(e.HorizontalGutter,{gutter:20},p.createElement(e.Space,{spacing:6},p.createElement(e.Space,{spacing:4},p.createElement(e.Brand,null,p.createElement(k,null,`${t.brand} ${t.brandModel}`)),p.createElement(k,null,p.createElement(e.Name,null,t.name))),p.createElement(e.Space,{spacing:8},p.createElement(b,{product:t},p.createElement(b.Static,null)),p.createElement(e.Price,{price:{from:{value:t.priceFrom,currency:"USD"},to:{value:t.priceTo,currency:"USD"}},minimum:t.minimumOrdersNumber}))))))),p.createElement(e.HorizontalGutter,{gutter:20},p.createElement(L,{$size:"large"},l))))),Nr=()=>p.createElement(w,{gap:8},p.createElement(Ir,{ratio:"7.5:10"},p.createElement(w.Shape,{width:"100%"})),p.createElement(w.Shape,{width:"66%",height:16}),p.createElement(w.Shape,{width:"80%",height:24}),p.createElement(w.Shape,{width:"75%",height:16}),p.createElement(w,{aligment:"horizontal",gap:8},p.createElement(w.Shape,{radius:"50%",width:12,height:12}),p.createElement(w.Shape,{radius:"50%",width:12,height:12}),p.createElement(w.Shape,{radius:"50%",width:12,height:12})));$r.Skeleton=Er(Nr);import{useState as Lr}from"react";var Ln=({product:o})=>{let[t,r]=Lr(Object.values(o.groupedProductionMethods)?.[0]?.[0]?.productionMethod??null),{activeColorVariant:n}=I(),i=Object.values(o.groupedProductionMethods).flat().find(({productionMethod:l})=>l===t),a=t&&i?i:{slug:o.slug,priceFrom:o.priceFrom,priceTo:o.priceTo,minimumOrdersNumber:o.minimumOrdersNumber,productionMethod:o.productionMethod,colorVariants:o.variants,badges:o.badges};return{product:o,activeProduct:a,activeColorVariant:n,setActiveProductionMethod:r}};import $,{useState as et}from"react";import{Colorway as Qr}from"@fourthwall/components/dist/common/Colorway";import{Gallery as qr}from"@fourthwall/components/dist/common/Gallery/Gallery";import Gr,{createContext as Hr,useContext as Ur,useMemo as jo}from"react";import{useMemo as Or,useState as Dr}from"react";var qo=(o,t)=>{let[r,n]=Dr(t??o[0]),i=(u,y)=>o.find(B=>B.size===u&&B.color.name===y),a=u=>o.find(y=>y.size===u),l=u=>{n(a(u)??o[0])},c=u=>o.find(y=>y.color.name===u),C=u=>{n(c(u)??o[0])},V=Or(()=>o.filter(u=>u.size===r.size).map(u=>u.color),[r.size,o]);return{activeVariant:r,setActiveVariant:n,activeVariantColors:V,getVariantBy:i,getVariantBySize:a,setActiveVariantBySize:l,getVariantByColor:c,setActiveVariantByColor:C}};var Yo=Hr(void 0);function Wn({variants:o,initialVariant:t,children:r}){let{activeVariant:n,activeVariantColors:i,setActiveVariant:a,getVariantBy:l,getVariantBySize:c,setActiveVariantBySize:C,getVariantByColor:V,setActiveVariantByColor:u}=qo(o,t??o[0]),y=jo(()=>[...new Set(o.map(h=>h.size))],[o]),B=jo(()=>[...new Map(o.map(h=>[h.color.name,h.color])).values()],[o]);return Gr.createElement(Yo.Provider,{value:{variants:o,variantsUniqueSizes:y,variantsUniqueColors:B,activeVariant:n,activeVariantColors:i,setActiveVariant:a,getVariantBy:l,getVariantBySize:c,setActiveVariantBySize:C,getVariantByColor:V,setActiveVariantByColor:u}},r)}function D(){let o=Ur(Yo);if(o===void 0)throw new Error("useProductVariantContext must be used within a ProductVariantContextProvider");return o}import{Select as Fr}from"@fourthwall/components/dist/inputs/Select";import Xo from"react";import Wr from"styled-components";var Jo=Wr.div`
  max-width: 150px;
`;var Ro=({onSizeChange:o})=>{let{variantsUniqueSizes:t,activeVariant:r,setActiveVariant:n,getVariantBySize:i}=D(),a=l=>{n(c=>{let C=i(l);return C?(o?.(C),C):c})};return Xo.createElement(Jo,null,Xo.createElement(Fr,{label:"Size",options:t.map(l=>({label:l,value:l})),size:"small",value:r.size,onChange:l=>{a(l.target.value)}}))};import{mediaQueries as Zr}from"@fourthwall/components/dist/providers/MediaQueryProvider";import po from"styled-components";var ot=po.div`
  position: relative;
`,tt=po.div`
  position: absolute;
  top: 10px;
  right: 10px;
`,rt=po.div`
  position: absolute;
  top: 10px;
  left: 10px;

  ${Zr.laptop} {
    /* TODO: Temporary hack as to do it properly it
  is required to modify generic <Gallery/> component */
    left: 110px;
  }
`;var ra=({designingType:o})=>{let{activeVariant:t,setActiveVariant:r,variantsUniqueSizes:n,variantsUniqueColors:i,getVariantByColor:a}=D(),[l,c]=et(!1),[C,V]=et(null),u=h=>{V(h),c(!0)},y=()=>{c(!1)},B=h=>{let ht=a(h)??t;r(ht)};return $.createElement(ot,null,$.createElement(qr,{photos:t.photos.map(h=>({image:{url:h.url,width:1536,height:2048},thumbnail:{url:h.thumbnailUrl,width:478,height:637}})),zoom:!0,activePhoto:C,activeModal:l,onClose:y,onClick:u}),o==="PER_SIZE"&&n.length>1&&$.createElement(rt,null,$.createElement(Ro,null)),i.length>1&&$.createElement(tt,null,$.createElement(Qr,{colors:i.map(h=>({label:h.name,value:h.swatch})),direction:"vertical",activeColor:t.color.name,onChange:h=>{B(h.label)}})))};import{Button as Ct}from"@fourthwall/components/dist/common/Button";import{useCopyToClipboard as Yr}from"@fourthwall/components/dist/hooks/useCopyToClipboard";import{ModalBox as Jr}from"@fourthwall/components/dist/partials/ModalBox";import{Skeleton as G}from"@fourthwall/components/dist/partials/Skeleton";import{DuplicateIcon as Xr,HeartIcon as Rr,TickIcon as oe}from"@fourthwall/icons";import m from"react";import S,{css as jr}from"styled-components";var nt=S.div`
  display: flex;

  p {
    color: var(--text-primary);
    /* body/sm/regular */
    font-family: var(--font-family-body);
    font-size: var(--font-size-300);
    font-style: normal;
    font-weight: var(--font-weight-regular);
    line-height: var(--font-line-height-300);
    letter-spacing: var(--font-letter-spacing-loose);
  }
`,at=S.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-400);
`,it=S.div`
  height: 120px;
  aspect-ratio: 3 / 4;
  background: grey;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`,st=S.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
`,dt=S.div`
  color: var(--text-secondary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-200);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-200);
  letter-spacing: var(--font-letter-spacing-dense);
`,lt=S.div`
  color: var(--text-primary);
  font-family: var(--font-family-heading);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-dense);
`,ct=S.div`
  color: var(--text-primary-invert);

  display: flex;
  padding: var(--space-250) var(--space-300);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-150);
  align-self: stretch;

  border-radius: var(--radius-brand);
  background: var(--bg-success);
`,pt=S.h4`
  color: var(--text-primary-invert);
  /* heading/sm */
  font-family: var(--font-family-heading);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-dense);
`,ut=S.p`
  color: var(--text-primary-invert);

  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
`,uo=S.div`
  & > * + * {
    ${({$spacing:o=20})=>jr`
      margin-top: ${o}px;
    `}
  }
`;var pa=({product:o,banner:t,disabled:r,isFavorite:n,onAdd:i,onRemove:a,onClose:l})=>{let{isCopied:c,copyToClipboard:C}=Yr(),V=n?"#fff":"none",u=async()=>{n?await a?.():await i?.()},y=async()=>{try{await navigator.share({url:window.location.href})}catch(B){if(B instanceof Error&&B.toString().includes("AbortError"))return;C(window.location.href)}};return m.createElement(Jr,{title:"Designing works best on desktop",onClose:l},m.createElement(nt,{"data-analytics-viewed":"mobileProductFavoritesModal"},m.createElement(uo,{$spacing:20},m.createElement("p",null,"Product customizing isn't available on mobile yet. You can add product to favorites and continue on a larger screen."),m.createElement(at,null,m.createElement(it,null,o?m.createElement("img",{src:o.colorVariants[0].photos[0].thumbnailUrl}):m.createElement(G,null,m.createElement(G.Shape,{width:"100%",height:120}))),m.createElement(st,null,m.createElement(dt,null,o?m.createElement(m.Fragment,null,o.brand," ",o.brandModel):m.createElement(G,null,m.createElement(G.Shape,{width:"50%"}))),m.createElement(lt,null,o.name))),t,m.createElement(uo,{$spacing:12},m.createElement(Ct,{leftIcon:m.createElement(Rr,{fill:V,width:16,height:16}),label:n?"Favorited":"Favorite",appearance:"primary",size:"medium",fullWidth:!0,disabled:r,onClick:u,analytics:"mobileProductFavoritesButton"}),m.createElement(Ct,{leftIcon:c?m.createElement(oe,{width:16,height:16}):m.createElement(Xr,{width:16,height:16}),label:c?"Copied":"Copy link",appearance:"secondary",size:"medium",fullWidth:!0,onClick:y,analytics:"mobileProductCopyLinkButton"})))))};import{PriceString as te}from"@fourthwall/components/dist/functional/PriceString";import H from"react";var Pt="CREATE_N_OR_MORE_PRODUCTS",vt="SAMPLE_BUDGET",Pa=({campaign:o})=>{if(!o||!o.campaignIncentives)return null;let t=o?.campaignIncentives?.find(r=>r.type===Pt&&r.bonus.type===vt)||null;if(!t?.isCompleted&&t?.type===Pt&&t?.bonus?.type===vt&&t.amountToCreate>0){let r=t.bonus;return H.createElement(ct,{"data-analytics":"sample-budget-campaign-banner"},H.createElement(pt,null,"Limited offer"),H.createElement(ut,null,"You\u2019ll earn ",H.createElement(te,{value:r.amount.value,currency:r.amount.currency})," of sample credit for creating your first ",t.amountToCreate," ",t.amountToCreate===1?"product":"products","."))}return null};export{pa as AddProductToFavoritesModal,Pa as CampaignBanner,O as ProductBox,$r as ProductBoxCustomizable,Ar as ProductBoxStatic,Ee as ProductColorVariantProvider,ra as ProductShowcase,Wn as ProductVariantContextProvider,Ln as useProductBox,I as useProductColorVariantContext,D as useProductVariantContext};
//# sourceMappingURL=index.js.map